import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, FileText, Video, Scissors, Rocket, UserPlus, MessageSquare, Zap } from "lucide-react";
import { FadeUp, MaskedLines } from "../site/Motion";
import { trackCta } from "../../lib/analytics";

const CHAIN = [
  ["Script", FileText], ["Film", Video], ["Edit", Scissors], ["Launch", Rocket], ["Generate Leads", UserPlus], ["Follow Up", MessageSquare],
];

export function ProcessFinale() {
  return (
    <section className="relative overflow-hidden border-y border-white/[0.06] bg-char py-24 lg:py-32" data-testid="process-finale">
      <div className="container-x">
        <div className="relative">
          <motion.div className="absolute left-[8%] right-[8%] top-7 hidden h-px origin-left bg-gradient-to-r from-electric via-cyan-300 to-electric md:block"
            initial={{ scaleX: 0 }} whileInView={{ scaleX: 1 }} viewport={{ once: true, amount: 0.3 }} transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }} />
          <ol className="relative grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 md:grid-cols-6">
            {CHAIN.map(([label, Icon], i) => (
              <FadeUp as="li" key={label} delay={0.12 * i} className="flex flex-col items-center text-center">
                <span className="grid h-14 w-14 place-items-center rounded-2xl border border-electric/40 bg-ink text-cyan-300 shadow-[0_0_30px_-8px_rgba(0,136,255,0.8)]">
                  <Icon className="h-5 w-5" />
                </span>
                <span className="mt-3 font-mono text-[11px] uppercase tracking-[0.18em] text-slate-300">{String(i + 1).padStart(2, "0")} · {label}</span>
              </FadeUp>
            ))}
          </ol>
        </div>

        <div className="mt-20 grid items-end gap-12 lg:grid-cols-[1.4fr_1fr]">
          <div>
            <MaskedLines as="h2" inView lines={["We Handle Everything.", <span className="font-serif italic font-normal text-gradient">You Focus on Your Business.</span>]}
              className="text-[2.2rem] leading-[1.02] sm:text-5xl lg:text-[4.2rem] font-semibold tracking-[-0.04em] text-white" />
            <FadeUp delay={0.2} className="mt-10">
              <Link to="/get-started" data-testid="process-finale-cta-btn" onClick={() => trackCta("See What We Can Do for You", "process")} className="btn-primary group">
                See What We Can Do for You <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
            </FadeUp>
          </div>
          <FadeUp delay={0.3} className="rounded-3xl glass p-7" data-testid="followup-stat-card">
            <Zap className="h-6 w-6 text-cyan-300" />
            <p className="mt-5 text-2xl font-semibold tracking-tight text-white">Faster Follow-Up. More Opportunities to Convert.</p>
            <p className="mt-3 text-sm leading-relaxed text-slate-400">Quick responses help you connect with interested customers while your business is still top of mind.</p>
          </FadeUp>
        </div>
      </div>
    </section>
  );
}
